/* ═══════════════════════════════════════════════════════════════
   REUNITED — Mini music player (persistent across pages)
   Tracks come from the section's blocks (JSON in [data-mp-tracks]).
   Playback state (track, position, playing) is saved continuously to
   sessionStorage, so navigating to another page resumes exactly where
   the music left off. If the browser blocks un-gestured resume, the
   very first tap/click/keypress on the new page resumes it.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var root = document.getElementById('ru-mp');
  if (!root) return;

  var DISMISS_KEY = 'ru-mp-dismissed';
  var STATE_KEY = 'ru-mp-state';
  var remember = root.getAttribute('data-autohide') === 'true';

  function readJSON(key) {
    try { return JSON.parse(sessionStorage.getItem(key)); } catch (e) { return null; }
  }
  function writeJSON(key, val) {
    try { sessionStorage.setItem(key, JSON.stringify(val)); } catch (e) {}
  }

  try {
    if (remember && sessionStorage.getItem(DISMISS_KEY) === '1') { root.hidden = true; return; }
  } catch (e) {}

  var tracks = [];
  try {
    tracks = JSON.parse(root.querySelector('[data-mp-tracks]').textContent) || [];
  } catch (e) { tracks = []; }
  tracks = tracks.filter(function (t) { return t && t.url; });
  if (!tracks.length) { root.hidden = true; return; }

  var audio = new Audio();
  audio.preload = 'metadata';

  var i = 0;
  var closed = false;
  var titleEl = root.querySelector('[data-mp-title]');
  var artistEl = root.querySelector('[data-mp-artist]');
  var playBtn = root.querySelector('[data-mp-play]');
  var icPlay = root.querySelector('[data-ic-play]');
  var icPause = root.querySelector('[data-ic-pause]');

  function render() {
    var t = tracks[i];
    if (titleEl) titleEl.textContent = t.title || 'Untitled';
    if (artistEl) artistEl.textContent = t.artist || '';
  }
  function setPlayingUI(on) {
    root.classList.toggle('is-playing', on);
    if (icPlay) icPlay.style.display = on ? 'none' : '';
    if (icPause) icPause.style.display = on ? '' : 'none';
    if (playBtn) playBtn.setAttribute('aria-label', on ? 'Pause' : 'Play');
  }

  /* ── State persistence ── */
  var lastSave = 0;
  function save(playing) {
    if (closed) return;
    writeJSON(STATE_KEY, { i: i, t: audio.currentTime || 0, p: !!playing });
  }
  audio.addEventListener('timeupdate', function () {
    var now = Date.now();
    if (now - lastSave > 1500) { lastSave = now; save(!audio.paused); }
  });
  window.addEventListener('pagehide', function () { save(!audio.paused); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') save(!audio.paused);
  });

  /* ── Core controls ── */
  function load(n, autoplay, seekTo) {
    i = ((n % tracks.length) + tracks.length) % tracks.length;
    audio.src = tracks[i].url;
    render();
    if (typeof seekTo === 'number' && seekTo > 0) {
      var onMeta = function () {
        audio.removeEventListener('loadedmetadata', onMeta);
        if (isFinite(audio.duration) && seekTo < audio.duration - 1) {
          try { audio.currentTime = seekTo; } catch (e) {}
        }
      };
      audio.addEventListener('loadedmetadata', onMeta);
      audio.load();
    }
    if (autoplay) play();
  }
  function play() {
    try {
      var p = audio.play();
      if (p && p.catch) p.catch(function () { setPlayingUI(false); armGestureResume(); });
    } catch (e) { armGestureResume(); }
  }

  /* If the browser blocks resume after navigation (autoplay policy),
     resume on the first user interaction with the new page. */
  var armed = false;
  function armGestureResume() {
    if (armed || closed) return;
    armed = true;
    var events = ['pointerdown', 'touchstart', 'keydown'];
    var handler = function () {
      events.forEach(function (ev) { window.removeEventListener(ev, handler, true); });
      armed = false;
      if (!closed && audio.paused) {
        try { var p = audio.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
      }
    };
    events.forEach(function (ev) { window.addEventListener(ev, handler, true); });
  }

  audio.addEventListener('play', function () { setPlayingUI(true); save(true); });
  audio.addEventListener('pause', function () { setPlayingUI(false); save(false); });
  audio.addEventListener('ended', function () { load(i + 1, true, 0); });
  audio.addEventListener('error', function () { setPlayingUI(false); });

  if (playBtn) playBtn.addEventListener('click', function () {
    if (!audio.src) load(i, true, 0);
    else if (audio.paused) play();
    else audio.pause();
  });
  var prev = root.querySelector('[data-mp-prev]');
  var next = root.querySelector('[data-mp-next]');
  if (prev) prev.addEventListener('click', function () { load(i - 1, !audio.paused, 0); });
  if (next) next.addEventListener('click', function () { load(i + 1, !audio.paused, 0); });

  var minBtn = root.querySelector('[data-mp-toggle-min]');
  if (minBtn) minBtn.addEventListener('click', function () { root.classList.toggle('is-min'); });

  var closeBtn = root.querySelector('[data-mp-close]');
  if (closeBtn) closeBtn.addEventListener('click', function () {
    closed = true;
    audio.pause();
    root.hidden = true;
    try { sessionStorage.removeItem(STATE_KEY); } catch (e) {}
    if (remember) { try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (e) {} }
  });

  /* ── Boot: restore where the last page left off ── */
  var state = readJSON(STATE_KEY);
  if (state && typeof state.i === 'number' && state.i >= 0 && state.i < tracks.length) {
    load(state.i, false, state.t || 0);
    if (state.p) {
      setPlayingUI(true);
      play();
    }
  } else {
    render();
  }
})();
